import { useQuery } from "@apollo/client/react";
import { useParams } from "react-router";

import EditableTemplate from "./EditableTemplate";
import { GET_TEMPLATE_BY_UUID } from "../../graphql/queries/GetTemplate";
import { AutosaveProvider } from "../../hooks/use-autosave";
import PageTitle from "../layout/PageTitle";

export default function EditTypedTemplate() {
  const { uuid } = useParams();
  const { data } = useQuery(GET_TEMPLATE_BY_UUID, {
    variables: { uuid },
    fetchPolicy: "network-only",
  });

  return (
    <div>
      <PageTitle title="Edit Template" />
      {data?.template ? (
        <AutosaveProvider>
          <EditableTemplate template={data?.template} />
        </AutosaveProvider>
      ) : null}
    </div>
  );
}
